/**
 * Pure helper that turns a nullable ISO-8601 timestamp into a
 * human-friendly relative "last used" label for the producer picker.
 */

const MINUTE_MS = 60_000;
const HOUR_MS = 3_600_000;
const DAY_MS = 86_400_000;

const dateFormat = new Intl.DateTimeFormat('en-CA', {
    month: 'short',
    day: 'numeric',
});

export function relativeUsedAt(
    iso: string | null,
    now: Date = new Date(),
): string {
    if (!iso) return 'Never used';

    const then = new Date(iso);
    const diffMs = now.getTime() - then.getTime();

    if (diffMs < MINUTE_MS) return 'Last used just now';

    const minutes = Math.floor(diffMs / MINUTE_MS);
    if (diffMs < HOUR_MS) {
        return `Last used ${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
    }

    const hours = Math.floor(diffMs / HOUR_MS);
    if (diffMs < DAY_MS) {
        return `Last used ${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
    }

    const days = Math.floor(diffMs / DAY_MS);
    if (days < 30) {
        return `Last used ${days} ${days === 1 ? 'day' : 'days'} ago`;
    }

    return `Last used ${dateFormat.format(then)}`;
}
